/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'sarsaparilla';
import { gnoment } from 'shared-ui/gnoment';
import { formatMoney } from '../../utils/utilsNew';

function PermitItem({ reservation }) {
    const description = reservation.order_details.description;
    const location = reservation.order_details.location;
    const recarea = reservation.order_details.recarea;
    const entryDate = gnoment.utc(reservation.order_details.entry_date).format('ll');
    const exitDate = gnoment.utc(reservation.order_details.exit_date).format('ll');
    return (
        <div className="cartoc-reservation cartoc-reservation-permit">
            <div className="cartoc-reservation-dates">
                <h4>
                    Entrance: <strong>{entryDate}</strong>
                </h4>
                <hr />
                <h4>
                    Exit: <strong>{exitDate}</strong>
                </h4>
            </div>
            <div className="cartoc-reservation-details">
                <div className="inventory-icon">
                    <Icon iconName="permit" />
                </div>
                <div className="cartoc-reservation-desc">
                    <h3>{description}</h3>
                    <p>
                        <i>{recarea}</i>
                    </p>
                    <p>{location}</p>
                </div>
            </div>
            <div className="cartoc-reservation-total">
                <p>
                    Subtotal: <strong>{formatMoney(reservation.subtotal)}</strong>
                </p>
                <p>
                    Quantity: <strong>1 Permit</strong>
                </p>
            </div>
        </div>
    );
}

PermitItem.propTypes = {
    reservation: PropTypes.object.isRequired,
};

export default PermitItem;
